import React, { useRef, ReactNode } from 'react';
import { useFilterSize } from 'components/TopicFilters/utils/useFilterSize';
import {
  DropdownLabel,
  DropdownWrapperStyle,
  WideSearchableMenu,
} from './shared/styles';
import useMedia from 'hooks/useMedia';

interface IDropdownWrapperProps {
  children: ReactNode;
  label?: string;
  hasWideSearchableMenu?: boolean;
  isEnabled?: boolean;
}

const DropdownWrapper: React.FC<IDropdownWrapperProps> = (props) => {
  const { children, label, hasWideSearchableMenu, isEnabled } = props;
  const ref = useRef(null);
  const isSmallScreen = useMedia('(max-width: 47em)');

  useFilterSize(ref);

  const WrapperElement = hasWideSearchableMenu
    ? WideSearchableMenu
    : DropdownWrapperStyle;

  return (
    <WrapperElement isEnabled={isEnabled} isSmallScreen={isSmallScreen}>
      {!!label && (
        <DropdownLabel ref={ref} isSmallScreen={isSmallScreen}>
          {label}
        </DropdownLabel>
      )}
      {children}
    </WrapperElement>
  );
};

export default DropdownWrapper;
